import React, { CSSProperties } from 'react';
import parser from 'html-react-parser';
import { CcIcon } from '@utp/components-react';

import * as S from './styled';

interface IProps {
  backgroundColor?: string;
  fontSize?: string;
  iconColor?: string;
  isRight?: boolean;
  lineHeight?: string;
  style?: CSSProperties;
  text: string;
  text2?: string;
  textColor?: string;
  iconName?: string;
  fullParser?: boolean;
  internalPadding?: string;
}

const ReusableInfo = ({
  backgroundColor,
  fontSize,
  iconColor,
  isRight,
  lineHeight,
  style,
  text,
  text2,
  textColor,
  iconName,
  fullParser,
  internalPadding
}: IProps) => (
  <S.Wrapper
    backgroundColor={backgroundColor}
    fontSize={fontSize}
    iconColor={iconColor}
    isRight={isRight}
    lineHeight={lineHeight}
    style={style}
    textColor={textColor}
    padding={internalPadding}
    data-testid="cmp-reusable-info"
  >
    <CcIcon size={20} name={iconName} />
    {fullParser ? (
      parser(text)
    ) : (
      <p style={{ textAlign: 'left' }}>
        {parser(text)}
        <span
          style={{
            fontWeight: 700,
            fontSize: '12px',
            lineHeight: '16px',
            color: '#161D1F'
          }}
        >
          {text2}
        </span>
      </p>
    )}
  </S.Wrapper>
);

ReusableInfo.defaultProps = {
  iconName: 'alert-circle'
};
export default ReusableInfo;
